import { useTranslation } from 'react-i18next'
import Score from './Score.jsx'
import SpiderChart from '../features/spiderChart/SpiderChart.jsx'
import { createPortal } from 'preact/compat'
import { useEffect, useRef, useState } from 'react'
import useActionCardData from '../hooks/useActionCardData'

const LastSlide = ({ showScore, finalSlideLayout }) => {
  const { t } = useTranslation()
  const ref = useRef()
  const [chartContainer, setChartContainer] = useState()
  const actionCardData = useActionCardData()

  useEffect(() => {
    setChartContainer(ref.current.querySelector('#chartContainer'))
  }, [])

  return (
    <div style={{ width: `${window.innerWidth}px` }} className={`shrink-0 transition-[filter] `}>
      <div
        className={`flex items-center justify-between border-b-[1px] dark:text-white border-solid border-wp-bg-gray text-[20px] w-full pb-[26px] pt-[22px] px-8`}
      >
        <div>{t('main.LastSlideTitle', 'End')}</div>
        {showScore && actionCardData && <Score value={actionCardData.score} />}
      </div>
      <div className="overflow-auto h-full">
        <div
          ref={ref}
          className={`px-8 pb-36 twp`}
          dangerouslySetInnerHTML={{ __html: makeChartContainer(finalSlideLayout) }}
        />
      </div>

      {chartContainer && createPortal(<SpiderChart />, chartContainer)}
    </div>
  )
}

function makeChartContainer(html) {
  if (!html) return ''
  return html?.replace('{{scoring-chart}}', '<div id="chartContainer" style="width: 100%"></div>')
}

export default LastSlide
